/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/cottonSmall.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh012.geometry}
				material={materials["Floral Fabric.003"]}
				scale={0.433}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh012_1.geometry}
				material={materials["Cotton pad muji.001"]}
				scale={0.433}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh012_2.geometry}
				material={materials["leafGreen.002"]}
				scale={0.433}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh012_3.geometry}
				material={materials["Muddy Soil Gravel.001"]}
				scale={0.433}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh012_4.geometry}
				material={materials["Clean chrome"]}
				scale={0.433}
			/>
		</group>
	);
}

useGLTF.preload("models/cottonSmall.glb");
